import React from 'react';

import { getRouteApi } from '@tanstack/react-router';
import { LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import TitleDateInput from '../inputs/general/TitleDateInput.tsx';
import TitleInput from '../inputs/general/TitleInput.tsx';
import TitleCurrencyInput from '~/features/leadDetails/components/Overview/CustomerData/Employment/inputs/general/TitleCurrencyInput.tsx';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

const Azubi: React.FC<{ secondApplicant?: boolean }> = ({ secondApplicant }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { t } = useTranslation();
    const employmentTranslationPath = 'CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT';
    const incomeTranslationPath = 'CREDIT_WORTHINESS.SECTIONS.INCOME';

    const paths = {
        endOfTraining: 'beschaeftigung.azubi.endeDerAusbildung',
        schoolLocation: 'beschaeftigung.azubi.schulStandort',
        schoolName: 'beschaeftigung.azubi.schulName',
        trainingCompensation: 'beschaeftigung.azubi.ausbildungsVerguetungMonatlich',
    };

    const isDisabled = !canExecuteApplicantCommand({
        applicant: secondApplicant ? 2 : 1,
        commandName: LOAN_REQUEST_COMMANDS.changeApplicantEmployment,
        permissions,
    });

    return (
        <>
            <FormCard
                data-testid={'azubi-sub-form'}
                title={t(`${employmentTranslationPath}.SUBSECTIONS.INCOME_HEALTH_INSURANCE`)}
            >
                <TitleCurrencyInput
                    title={t(`${incomeTranslationPath}.TRAINING_COMPENSATION`)}
                    name={paths.trainingCompensation}
                    disabled={isDisabled}
                />
                <TitleDateInput
                    title={t(`${employmentTranslationPath}.END_OF_TRAINING`)}
                    name={paths.endOfTraining}
                    disabled={isDisabled}
                />
                <TitleInput
                    title={t(`${employmentTranslationPath}.SCHOOL_NAME`)}
                    name={paths.schoolName}
                    disabled={isDisabled}
                />
                <TitleInput
                    title={t(`${employmentTranslationPath}.SCHOOL_LOCATION`)}
                    name={paths.schoolLocation}
                    disabled={isDisabled}
                />
            </FormCard>
        </>
    );
};

export default Azubi;
